import BpkText, {
  TEXT_STYLES,
  TEXT_COLORS,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import classnames from 'classnames';

import { withI18n } from '../../../hotels-utils/services/i18n';

import type { I18n } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

import STYLES from './PriceSummary.module.scss';

type PriceSummaryProps = {
  i18n: I18n;
};

const PriceSummary = ({ i18n }: PriceSummaryProps) => {
  const mainPriceNode = () => {
    const mainPriceLabel = 'OTARate_label_priceForANight';

    const classNameForMain = classnames(
      STYLES.PriceSummary__label,
      STYLES.PriceSummary__labelOnlyText,
    );

    return (
      <BpkText
        tagName="p"
        color={TEXT_COLORS.textSecondary}
        textStyle={TEXT_STYLES.footnote}
        className={classNameForMain}
      >
        {i18n.translate(mainPriceLabel, {
          price: null,
        })}
      </BpkText>
    );
  };

  return <>{mainPriceNode()}</>;
};

export default withI18n(PriceSummary);
